import styles from "./ProspectInfo.module.css";
import { InTheProcess } from "./sections/InTheProcess/InTheProcess";
import { BSMsCheckedOut } from "./sections/BSMsCheckedOut/BSMsCheckedOut";
import { Notes } from "./sections/Notes/Notes";
import { History } from "./sections/History/History";
import { ContactView } from "shared/components/ContactView/ContactView";
import { Button } from "@wwg/ui";
import { useTranslation } from "react-i18next";
import { hasBitwise } from "shared/utils/hasBitwise";
import { CONTACT_TYPE } from "shared/enums";

export function ProspectInfo({ contact, onEditClicked, onUnarchiveClicked }) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <ContactView contact={contact} />
        <div className={styles.controls}>
          {hasBitwise(CONTACT_TYPE.Archived, contact.type) ? (
            <Button buttonStyle="hollowBronze" onClick={onUnarchiveClicked}>
              {t("buttons.unarchive")}
            </Button>
          ) : (
            <Button buttonStyle="hollow" onClick={onEditClicked}>
              {t("buttons.edit")}
            </Button>
          )}
        </div>
      </div>

      <div className={styles.mainContent}>
        <InTheProcess contact={contact} />

        <div className={styles.sections}>
          <BSMsCheckedOut contact={contact} />
          <hr className={styles.divider} />
          <Notes contact={contact} />
          <hr className={styles.divider} />
          <History contact={contact} />
        </div>
      </div>
    </div>
  );
}

ProspectInfo.propTypes = {
  contact: ContactView.propTypes.contact,
};
